"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrders = void 0;
const react_1 = require("react");
const OrdersContext_1 = require("./OrdersContext");
const useOrders = () => {
    const context = (0, react_1.useContext)(OrdersContext_1.OrdersContext);
    if (!context) {
        throw new Error('useOrders must be used within an OrdersProvider');
    }
    return context;
};
exports.useOrders = useOrders;
